import React from "react";
import FormSpinner from "../../forms/formSpinner/formSpinner.component";

function Spinner() {
  return (
    <div className="min-w-screen min-h-[80vh] flex justify-center items-center">
      <FormSpinner />
    </div>
  );
}

export default Spinner;
